/**
 * The app's breadcrumb on the Kestrel pack's passport page, built the way
 * Passport/Internal/Show.jsx builds it: Passports, the ontology (which opens
 * the root passport), each ancestor below the root as "Level · ID", then the
 * passport itself.
 */
export default function packBreadcrumb(kestrel) {
    const passport = kestrel.pack.passport;

    return [
        'Passports',
        kestrel.ontology.name,
        ...(passport.ancestors ?? []).slice(1).map((ancestor) => (
            [ancestor.depth_name, ancestor.friendly_id || ancestor.snowflake].filter(Boolean).join(' · ')
        )),
        passport.friendly_id || passport.snowflake,
    ];
}
